import React, { useState, useRef ,useEffect} from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useCountry } from '../pages/CountryContext'; // Adjust path as needed
import { useNavigate } from 'react-router-dom';

import { setDoc, doc, serverTimestamp, getDoc,  updateDoc, arrayUnion, deleteDoc } from 'firebase/firestore';

const ViewRegistration = ({ selectedRegistrationType }) => {
  const [searchId, setSearchId] = useState("");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { selectedCountry } = useCountry();
  const [activeButton, setActiveButton] = useState(0);
  const [activeTab, setActiveTab] = useState("farmers");
  const navigate = useNavigate();

  const buttons = [
    { label: "View Registration", path: "/document" },
    { label: "Verify Registration", path: "/document" },
    { label: "Share Registration", path: "/document" },
    { label: "-", path: "/" }, // You can update these paths as needed
    { label: "-", path: "/" },
    { label: "-", path: "/" },

    { label: "-", path: "/" },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const getReferralData = (userData) => {
    if (!userData) return null;
    
    return userData.referralData || {
      referralCode: "",
      referredBy: "",
      referralDate: "",
      hasReferral: false
    };
  };

  const renderReferralSection = () => {
    const referralData = getReferralData(userData);
    
    if (!referralData || !referralData.hasReferral) {
      return null; // Don't render if no referral data exists
    }
    
    return (
      <div className="mb-6 md:mb-8 md:mt-16 mt-2">
     
<div className="mt-2 md:mt-8 mb-1">
  <div className="flex items-center justify-between mb-2">
    {/* Referral Checkbox - Half Width */}
    <div className="w-1/2">
      <button
        className={`
          flex items-center justify-between
          bg-[#F5F5F5]
          border border-[#F5F5F5] rounded-l-[5px]
          md:px-4 px-2
          md:h-[80px] h-[20px]
          w-full
          cursor-pointer
        `}
    
      >
        <span className="text-[4px] md:text-[24px] font-bold leading-[1.10]">
          Referral
        </span>
        <span
          className={`
            md:w-14 md:h-14 w-4 h-4 rounded-full flex-shrink-0
        bg-[#152C24] md:border-[6px] border-[1px] border-white" 
          `}
        />
      </button>
      <p className="md:text-[20px] text-[6px] text-white font-medium italic mt-1">
        Enter referral code if applicable
      </p>
    </div>
    
    {/* Input Field - Half Width */}
    <div className="w-1/2">
 
      <div className="   w-full bg-[#152C24] placeholder-white text-white 
      rounded-r-[5px] 
          md:py-2 py-1 md:h-[80px] h-[20px] md:px-4 px-2 flex justify-center items-center">
        <h1 className=" md:text-[24px] text-[6px] font-bold text-white ">{referralData.referralCode}</h1>

      </div>
      <p className="md:text-[20px] text-[6px] font-medium italic mt-1">
        Enter unique user number of person referring you
      </p>
    </div>
  </div>
</div>
      </div>
    );
  };
  const getPromotionData = (userData) => {
    if (!userData) return null;
    
    // Check multiple possible locations for promotion data
    const promotionData = userData.promotionData || 
                         userData.marketingData || 
                         {};
    
    return {
      selectedType: promotionData.selectedType || "ADVERTISEMENT",
      advertisementCards: promotionData.advertisementCards || 
                         promotionData.advertisements || 
                         [],
      promoCards: promotionData.promoCards || 
                  promotionData.promotions || 
                  []
    };
  };
  const PromotionDisplaySection = ({ userData }) => {
    const promotionData = getPromotionData(userData);
    
    if (!promotionData || (!promotionData.advertisementCards.length && !promotionData.promoCards.length)) {
      return null; // Don't render if no promotion data exists
    }
    
    const selectedType = promotionData.selectedType;
    const cardsToShow = selectedType === "PROMOTION" ? promotionData.promoCards : promotionData.advertisementCards;
    
    return (
      <div className="w-full flex flex-col gap-4 mt-6 mb-2 md:mb-12">
        {/* Dropdown showing the user's selection */}
        <div className="mt-4 flex justify-between items-center">
          <div className="flex flex-col w-full relative">
            <div className="flex relative z-20 w-full">
              <button className={`md:w-[520px] w-[80px] h-[15px] md:h-[64px] bg-[#152C24] rounded-[5px] flex items-center justify-between pl-4`}>
                <span className="md:text-[32px] text-[6px] truncate font-bold text-white">
                  {selectedType}
                </span>
              </button>
              <div className="md:h-[64px] h-[15px] w-[20px] md:w-[80px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                  alt="expand"
                  className="md:w-6 w-2 h-[8px] md:h-[24px]"
                />
              </div>
            </div>
          </div>
          
          <h1 className="md:text-[24px] font-normal text-[6px]">
            Add your product or services now to get seen by customers on the online marketplace
          </h1>
        </div>
        
        {/* Render cards based on user's selection */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-2 md:gap-x-10">
          {cardsToShow.slice(0, 4).map((card, index) => (
            <PromotionDisplayCard key={index} cardData={card} />
          ))}
          
          {/* Fallback if no cards exist */}
          {cardsToShow.length === 0 && (
            <div className="col-span-2 text-center py-8">
              <p className="text-gray-500 text-[6px] md:text-[14px]">
                No {selectedType.toLowerCase()} cards created during registration
              </p>
            </div>
          )}
        </div>
      </div>
    );
  };
  
  // Component to display individual promotion cards
  const PromotionDisplayCard = ({ cardData }) => {
    return (
      <div className="overflow-hidden">
        {/* Main image */}
        <div className='relative' style={{ backgroundColor: cardData.bgColor || 'transparent' }}>
          {cardData.mainImage ? (
            <img 
              src={cardData.mainImage} 
              alt="Main" 
              className="md:h-[350px] h-[120px] rounded-[2px] w-full object-cover" 
            />
          ) : (
            <div className="md:h-[350px] h-[120px] rounded-[2px] bg-[#D9D9D9] flex items-center justify-center">
              <span className="text-gray-500 text-[8px] md:text-[14px]">No image</span>
            </div>
          )}
          
          {/* Special Offer badge */}
          {cardData.badgeImage && (
            <div className="absolute bottom-[15px] right-2 md:w-[128px] w-[60px] h-[60px] md:h-[128px]">
              <img
                src={cardData.badgeImage}
                alt="Special Offer"
                className="w-full h-full object-contain"
              />
            </div>
          )}
        </div>
        
        {/* Bottom content */}
        <div className="w-full bg-white px-1 py-1">
          <div className="flex items-center justify-between mb-1">
            <h2 className="md:text-[32px] text-[8px] font-bold text-black italic">
              {cardData.title || "No title"}
            </h2>
            
            <span className="text-[8px] md:text-[12px] italic text-[#979797]">
              Additional text
            </span>
          </div>
          
          <div className="flex justify-between items-start">
            <p className="md:text-[24px] text-[6px] font-normal leading-snug whitespace-pre-line text-black italic">
              {cardData.description || "No description available"}
            </p>
          </div>
        </div>
      </div>
    );
  };
  const [paymentRule, setPaymentRule] = useState("Monthly");
  const getSelectedProductType = () => {
    if (!userData) return "PRODUCTS";
    
    // Check multiple possible locations for the selected product type
    return userData.selectedProductType || 
           userData.productsData?.selectedType || 
           "PRODUCTS"; // Default to PRODUCTS
  };

  const rows = [
    { label: "Website" },
    { label: "Catalogue" },
    { label: "Invoice" },
    { label: "Transaction" },
    { label: "Emails / Chat (CRM)" },
  ];

  const StarRating = ({ rating = 4.86 }) => {
    return (
      <div className="flex items-center -gap-1 md:-gap-2">
        <div className="flex">
          {[...Array(5)].map((_, i) => (
            <svg 
              key={i} 
              className="w-3 h-3 sm:w-6 sm:h-6 text-yellow-400" 
              fill="currentColor" 
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          ))}
        </div>
        <span className="text-[8px] sm:text-[20px] font-bold text-black">{rating.toFixed(2)}</span>
      </div>
    );
  };
  const stakeholderCategories = [
    {
      id: 'ALL',
      title: 'ALL',
      description: 'Select all stakeholder categories at once'
    },
    {
      id: 'Government Agencies',
      title: 'Government Agencies',
      description: 'Ministries and local government entities that provide policy support, funding, and formalization services for entrepreneurs',
      challenges: 'Challenges include bureaucratic delays, complex application processes, and limited funding availability'
    },
    {
      id: 'Development Partners & Donor Agencies',
      title: 'Development Partners & Donor Agencies',
      description: 'International organizations that fund entrepreneurship programs, grants, and training initiatives',
      challenges: 'Funding cycles can be unpredictable, and requirements may be stringent with competitive application processes'
    },
    {
      id: 'Business Support Organizations',
      title: 'Business Support Organizations',
      description: 'Entities offering incubation, training, networking, and acceleration services to startups and SMEs',
      challenges: 'Limited capacity to serve all entrepreneurs, with some programs being urban-centric and excluding rural businesses'
    },
    {
      id: 'Financial Institutions',
      title: 'Financial Institutions',
      description: 'Banks, microfinance institutions, and alternative lenders that provide capital to entrepreneurs',
      challenges: 'High collateral requirements, stringent credit assessments, and limited products tailored for early-stage businesses'
    },
    {
      id: 'Offtake & Market Partners',
      title: 'Offtake & Market Partners',
      description: 'Corporates, retailers, and platforms that connect entrepreneurs to markets and supply chain opportunities',
      challenges: 'Difficult entry requirements, large minimum order quantities, and payment terms that strain cash flow'
    },
    {
      id: 'NGOs & Nonprofits',
      title: 'NGOs & Nonprofits',
      description: 'Organizations providing targeted support to specific entrepreneur groups (youth, women, rural)',
      challenges: 'Limited scale, short-term project funding cycles, and sometimes restrictive eligibility criteria'
    },
    {
      id: 'Training & Academic Institutions',
      title: 'Training & Academic Institutions',
      description: 'Schools and programs offering digital skills, business management, and technical training',
      challenges: 'Curriculum may not always match market needs, and practical entrepreneurship training can be lacking'
    },
    {
      id: 'Regulatory & Compliance Bodies',
      title: 'Regulatory & Compliance Bodies',
      description: 'Entities responsible for business licensing, safety standards, and quality assurance',
      challenges: 'Complex compliance requirements, high costs of certification, and lengthy approval processes'
    },
    {
      id: 'Technology & Innovation Stakeholders',
      title: 'Technology & Innovation Stakeholders',
      description: 'Organizations fostering digital inclusion, innovation, and tech entrepreneurship',
      challenges: 'Limited infrastructure in some regions, high costs of technology adoption, and skills gaps'
    },
    {
      id: 'Research Institutions',
      title: 'Research Institutions',
      description: 'Universities and research centers providing technical expertise and innovation support',
      challenges: 'Limited practical application focus and accessibility for small entrepreneurs'
    },
    {
      id: 'Mentors & Advisors',
      title: 'Mentors & Advisors',
      description: 'Experienced professionals offering guidance and mentorship to entrepreneurs',
      challenges: 'Limited availability and accessibility for entrepreneurs in remote areas'
    },
    {
      id: 'Industry Associations',
      title: 'Industry Associations',
      description: 'Professional bodies representing specific industry sectors and interests',
      challenges: 'Membership costs and limited benefits for very small businesses'
    },
    {
      id: 'Others',
      title: 'Others',
      description: 'Additional stakeholder groups not covered by the main categories'
    },
    {
      id: '-',
      title: '-',
      description: ''
    }
  ];
  
  const [saving, setSaving] = useState(false);
  const contentRef = useRef(null);
  
  // Function to generate and download PDF
  const generatePDF = async () => {
    if (!contentRef.current) return;
    
    setSaving(true);
    try {
      const element = contentRef.current;
      
      // Store original styles
      const originalWidth = element.style.width;
      const originalOverflow = element.style.overflow;
      
      // Set fixed width for PDF generation
      element.style.width = '1240px';
      element.style.overflow = 'visible';
      
      const canvas = await html2canvas(element, {
        scale: 2, // Higher scale for better quality
        useCORS: true,
        allowTaint: true,
        logging: false,
        backgroundColor: '#ffffff',
        width: element.scrollWidth,
        height: element.scrollHeight,
        windowWidth: element.scrollWidth,
        scrollX: 0,
        scrollY: 0
      });
      
      // Restore original styles
      element.style.width = originalWidth;
      element.style.overflow = originalOverflow;
      
      const imgData = canvas.toDataURL('image/png');
      
      // Calculate PDF dimensions
      const pdfWidth = 210; // A4 width in mm (portrait)
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      
      // Create PDF
      const pdf = new jsPDF({
        orientation: pdfHeight > 297 ? 'portrait' : 'landscape',
        unit: 'mm',
        format: [pdfWidth, pdfHeight]
      });
      
      // Add image to PDF
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      
      // Generate filename with registration number if available
      const filename = userData 
        ? `registration_${userData.registrationNumber || 'document'}.pdf`
        : 'registration_document.pdf';
      
      pdf.save(filename);
    } catch (err) {
      console.error('Error generating PDF:', err);
      setError('Failed to generate PDF');
    } finally {
      setSaving(false);
    }
  };
  const getProductsData = () => {
    if (!userData) return [];
    
    // Check multiple possible locations for product data
    if (userData.productsData?.products) {
      return userData.productsData.products;
    }
    
    if (userData.products) {
      return Array.isArray(userData.products) ? userData.products : [userData.products];
    }
    
    // Fallback to empty array
    return [];
  };
  const renderProductsSection = () => {
    const selectedType = getSelectedProductType();
    const products = getProductsData();
    const services = userData?.productsData?.services || [];
    
    // Determine which data to show based on the selected type
    const itemsToShow = selectedType === "SERVICES" ? services : products;
    const sectionTitle = selectedType === "SERVICES" ? "SERVICES" : "PRODUCTS";
    
    if (itemsToShow.length === 0) {
      return (
        <div className="w-full mt-4">
          <div className="flex w-full">
            <button
              className={`md:w-[520px] w-[80px] h-[15px] md:h-[64px] bg-[#152C24] rounded-[5px] flex items-center justify-between pl-4`}
            >
              <span className="md:text-[32px] text-[6px] truncate font-bold text-white">
                {sectionTitle}
              </span>
            </button>
            <div
              className="md:h-[64px] h-[15px] w-[20px] md:w-[80px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
            >
            </div>
          </div>
        </div>
      );
    }
  
    return (
      <div className="w-full mt-4">
        <div className="flex w-full">
          <button
            className={`md:w-[520px] w-[80px] h-[15px] md:h-[64px] bg-[#2E453D] rounded-[5px] flex items-center justify-between pl-4`}
          >
            <span className="md:text-[32px] text-[6px] truncate font-bold text-white">
              {sectionTitle}
            </span>
          </button>
          <div
            className="md:h-[64px] h-[15px] w-[20px] md:w-[80px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
          >
          </div>
        </div>
  
        {itemsToShow.map((item, index) => {
          // Filter out items that don't have valid product names or user-uploaded images
          const validItems = item.items?.filter(subItem => {
            // Check if it has a valid product name (not empty and not placeholder)
            const hasValidName = subItem.name && 
                               subItem.name.trim() !== "" && 
                               subItem.name !== "XXXXX";
            
            // Check if it has a user-uploaded image (not default placeholder)
            const hasUserImage = subItem.cloudinaryUrl || 
                               (subItem.imageUrl && !subItem.imageUrl.includes('Rectangle_34643961')) ||
                               (subItem.image && !subItem.image.includes('Rectangle_34643961'));
            
            return hasValidName || hasUserImage;
          });
  
          // Only render the category if it has valid items
          if (!validItems || validItems.length === 0) {
            return null;
          }
  
          return (
            <div key={index} className="md:mt-2 mt-1">
              <div className="flex items-center border-b border-black md:mt-2 mt-1 pb-1 md:pb-2">
                <h2 className="md:text-[32px] text-[10px] font-bold w-[25%] md:w-[40%]">
                  {item.category || "Uncategorized"}
                </h2>
              </div>
  
              <div className="flex flex-wrap justify-start items-center md:gap-2 mt-1 md:mt-4">
                {validItems.slice(0, 4).map((subItem, subIndex) => {
                  // Check if this is a user-uploaded image or a default placeholder
                  const isUserUploadedImage = subItem.cloudinaryUrl || 
                                            (subItem.imageUrl && !subItem.imageUrl.includes('Rectangle_34643961')) ||
                                            (subItem.image && !subItem.image.includes('Rectangle_34643961'));
                  
                  // Only show image if it's user-uploaded and has a product name
                  const shouldShowImage = isUserUploadedImage && 
                                        subItem.name && 
                                        subItem.name.trim() !== "" && 
                                        subItem.name !== "XXXXX";
                  
                  return (
                    <div key={subIndex} className="md:w-[290px] w-[100px] relative mb-4">
                      {/* Item Title */}
                      <h3 className="md:text-[24px] text-[4px] md:mb-4 mb-1 min-h-[20px] md:min-h-[40px] flex items-center">
                        <span className="italic bg-transparent w-full">
                          {subItem.name || (selectedType === "SERVICES" ? "Service Name" : "Product Name")}
                        </span>
                      </h3>
  
                      {/* Item Image - Only show if user uploaded an image */}
                      <div className="relative">
                        {shouldShowImage ? (
                          <img
                            src={subItem.cloudinaryUrl || subItem.imageUrl || subItem.image}
                            alt={subItem.name || (selectedType === "SERVICES" ? "Service" : "Product")}
                            className="object-cover md:w-[290px] md:h-[180px] w-[78px] h-[50px] border border-gray-300 rounded"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'flex';
                            }}
                          />
                        ) : (
                          // Show empty state instead of placeholder image
                          <div className="bg-gray-100 md:w-[290px] md:h-[180px] w-[78px] h-[50px] flex items-center justify-center border border-gray-300 rounded">
                            <span className="text-gray-400 text-[4px] md:text-[12px]">
                              {subItem.name ? "No image uploaded" : "No product added"}
                            </span>
                          </div>
                        )}
                        
                        {/* Fallback for broken images */}
                        <div 
                          className="hidden bg-gray-200 md:w-[290px] md:h-[180px] w-[78px] h-[50px] flex items-center justify-center border border-gray-300 rounded"
                          style={{display: 'none'}}
                        >
                          <span className="text-gray-500 text-[4px] md:text-[12px]">Image not available</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  
  
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});

  // Initialize editData when userData changes
  useEffect(() => {
    if (userData) {
      const industryData = getIndustryData(userData);
      
      setEditData({
        firstName: userData.personalInfo?.firstName || userData.firstName || "",
        surname: userData.personalInfo?.surname || userData.surname || "",
        mobile: userData.personalInfo?.mobile || userData.mobile || "",
        email: userData.personalInfo?.email || userData.email || "",
        physicalAddress: userData.personalInfo?.physicalAddress || userData.physicalAddress || "",
        registrationNumber: userData.registrationNumber || "",
        aboutText: userData.aboutSection?.aboutText || userData.aboutText || "",
        tagline: userData.aboutSection?.tagline || userData.tagline || "",
        vision: industryData.vision // Include vision from industry data
      });
  
      // Set images if available
      if (userData.backgroundImage) {
        setBackgroundImage(userData.backgroundImage);
      }
      if (userData.profileImage?.url || userData.profileImage?.previewUrl) {
        setProfileImage(userData.profileImage.url || userData.profileImage.previewUrl);
      }
    }
  }, [userData]);
  
  
  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleEditChange = (field, value) => {
    setEditData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const getAboutText = () => {
    if (!userData) return "At Ubuntu Farm, nestled in the heart of Gauteng, we're a small, community-rooted farm dedicated to growing fresh, wholesome produce with care and passion...";
    
    // Check multiple possible locations for About Us text
    return userData.aboutSection?.aboutText || 
           userData.aboutText || 
           "At Ubuntu Farm, nestled in the heart of Gauteng, we're a small, community-rooted farm dedicated to growing fresh, wholesome produce with care and passion...";
  };

  const getTagline = () => {
    if (!userData) return "Customer is at the heart of our business";
    
    // Check multiple possible locations for Tagline
    return userData.aboutSection?.tagline || 
           userData.tagline || 
           "Customer is at the heart of our business";
  };

  const [backgroundImage, setBackgroundImage] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const handleSaveChanges = async () => {
    try {
      setLoading(true);
      
      // Update the user document in Firestore
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("registrationNumber", "==", userData.registrationNumber));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0];
        await updateDoc(doc(db, "users", userDoc.id), editData);
        
        // Update local state
        setUserData(prev => ({
          ...prev,
          ...editData
        }));
        
        setIsEditing(false);
        setError(""); // Clear any previous errors
      } else {
        setError("User document not found in database");
      }
    } catch (err) {
      console.error("Error updating user data:", err);
      setError("Failed to update user data");
    } finally {
      setLoading(false);
    }
  };
  const getNormalizedMembershipData = (userData) => {
    if (!userData) return { selected: [], customInputBoxes: [] };
    
    // Check multiple possible locations for membership data
    const membershipData = userData.membershipData || 
                          userData.membership || 
                          userData.organizationInfo?.membershipData || 
                          {};
    
    // Normalize the data structure
    return {
      selected: Array.isArray(membershipData.selected) ? membershipData.selected : [],
      customInputBoxes: Array.isArray(membershipData.customInputBoxes) ? membershipData.customInputBoxes : [],
      custom: Array.isArray(membershipData.custom) ? membershipData.custom : [],
      inputs: membershipData.inputs || {},
      organizationName: membershipData.organizationName || '',
      membershipNumber: membershipData.membershipNumber || '',
      membershipType: membershipData.membershipType || '',
      membershipDate: membershipData.membershipDate || ''
    };
  };
 

  const handleSearch = async () => {
    if (!searchId.trim()) {
      setError("Please enter a registration number");
      return;
    }
  
    setLoading(true);
    setError("");
    
    try {
      const registrationsRef = collection(db, "registrations");
      const q = query(registrationsRef, where("registrationNumber", "==", searchId.trim().toUpperCase()));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        setError("No registration found with this ID");
        setUserData(null);
      } else {
        const userDoc = querySnapshot.docs[0];
        const userDataFromFirebase = { 
          id: userDoc.id, 
          ...userDoc.data(),
          // Ensure all data is properly structured
          certificates: userDoc.data().certificates || 
                       userDoc.data().organizationInfo?.certificates ||
                       userDoc.data().certificatesUrls || [],
          membershipData: getNormalizedMembershipData(userDoc.data()),
          groupExperience: getGroupExperienceData(userDoc.data()),
          industry: getIndustryData(userDoc.data()),
          // Ensure data permissions are properly extracted
          dataPermissions: getDataPermissions(userDoc.data())
        };
        
        console.log('Fetched user data with data permissions:', {
          dataPermissions: userDataFromFirebase.dataPermissions,
          permissionsCount: userDataFromFirebase.dataPermissions.length,
          rawData: userDoc.data().dataPermissions || userDoc.data().dataSelections
        });
        
        setUserData(userDataFromFirebase);
      }
    } catch (err) {
      console.error("Error fetching user data:", err);
      setError("Failed to fetch registration data");
      setUserData(null);
    } finally {
      setLoading(false);
    }
  };

  const getCountryData = () => {
    if (!userData) return { name: "-", code: "-" };
    
    // Check various possible locations for country data
    if (userData.countryData?.name) {
      return {
        name: userData.countryData.name,
        code: userData.countryData.code || "-"
      };
    }
    
    if (userData.reportSelections?.COUNTRY) {
      const country = userData.reportSelections.COUNTRY;
      return {
        name: typeof country === 'object' ? country.name : country,
        code: typeof country === 'object' ? country.code : "-"
      };
    }
    
    return { name: "-", code: "-" };
  };

  const getLanguage = () => {
    if (!userData) return "-";
    
    // Check the correct location where language is stored in Firebase
    if (userData.dropdownSelections?.user_type) {
      return userData.dropdownSelections.user_type;
    }
    
    // Fallback to other possible locations (in order of priority)
    if (userData.languageData?.selected) {
      return userData.languageData.selected;
    }
    
    if (userData.language) {
      return userData.language;
    }
    
    if (userData.selectedLanguage) {
      return userData.selectedLanguage;
    }
    
    // If no language found, check report selections
    if (userData.reportSelections?.LANGUAGE) {
      return userData.reportSelections.LANGUAGE;
    }
    
    return "-";
  };

  const getFarmingType = () => {
    if (!userData) return "-";
    
    // Check various possible locations for farming type data
    if (userData.farmingTypeData?.type) {
      return userData.farmingTypeData.type;
    }
    
    if (userData.reportSelections?.["TYPE OF FARMING"]) {
      return userData.reportSelections["TYPE OF FARMING"];
    }
    
    return "-";
  };

  const getUserType = () => {
    if (!userData) return "-";
    
    // Check various possible locations for user type data
    if (userData.userTypeData?.type) {
      return userData.userTypeData.type;
    }
    
    if (userData.reportSelections?.["USER TYPE"]) {
      const userType = userData.reportSelections["USER TYPE"];
      return typeof userType === 'object' ? userType.name || userType.value : userType;
    }
    
    if (userData.dropdownSelections?.user_type) {
      return userData.dropdownSelections.user_type;
    }
    
    return "-";
  };
// Add this function to properly extract industry data
const getIndustryData = (userData) => {
  if (!userData) return { vision: "", challenges: [] };
  
  // Check multiple possible locations for industry data
  const industryData = userData.industry || 
                      userData.industrySurvey || 
                      userData.industryActivity || 
                      {};
  
  // Normalize challenges data
  let challenges = [];
  if (industryData.selectedChallenges && Array.isArray(industryData.selectedChallenges)) {
    challenges = industryData.selectedChallenges.map(challenge => ({
      title: challenge.title || "Challenge",
      description: challenge.description || "Description not available",
      solution: challenge.solution || "Solution not provided",
      code: challenge.code || ""
    }));
  }
  
  return {
    vision: industryData.vision || "To become a leading organic farm in the region",
    challenges: challenges
  };
};

// Update the Industry Section rendering function
const renderIndustrySection = () => {
  const industryData = getIndustryData(userData);
  
  return (
    <div className="mb-6 md:mb-10 md:mt-10">
      <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-4">
        INDUSTRY ACTIVITY SURVEY
      </h2>
      
      {/* Vision Section */}
      <p className="text-[6px] md:text-[32px] font-normal leading-[0.90] mb-2 text-[#979797]">
        What would you like to achieve (your vision and goals) in your enterprise pursuits and activities?
      </p>
      
      {isEditing ? (
        <textarea
          className="bg-transparent border border-gray-300 p-2 rounded outline-none focus:ring-0 focus:outline-none md:text-[24px] text-[6px] font-medium mb-4 md:mb-6 mt-3 w-full"
          value={editData.vision || industryData.vision}
          onChange={(e) => handleEditChange('vision', e.target.value)}
          placeholder="Enter your vision and goals"
          rows={3}
        />
      ) : (
        <p className="text-[6px] md:text-[24px] font-medium mb-4 md:mb-6 mt-3 bg-gray-50 p-2 rounded">
          {industryData.vision}
        </p>
      )}

      {/* Challenges Section */}
      <div>
        <h3 className="text-[8px] md:text-[32px] font-bold mb-3 md:mb-4 md:mt-8">
          INDUSTRY ACTIVITY SURVEY - CHALLENGES
        </h3>
        
        {industryData.challenges.length > 0 ? (
          <div className="space-y-2 md:space-y-4">
            {industryData.challenges.map((challenge, index) => (
              <div key={index} className=" pb-2 md:pb-4">
                <h4 className="text-[8px] md:text-[28px] font-bold text-[#152C24]">
                  {challenge.title}
                </h4>
                <p className="text-[6px] md:text-[20px] mt-1 md:mt-2 text-gray-700">
                  {challenge.description}
                </p>
                <p className="text-[6px] md:text-[20px] mt-1 md:mt-2 text-[#142B24] font-medium">
                  <strong>Solution:</strong> {challenge.solution}
                </p>
              </div>
            ))}
          </div>
        ) : (
          // Fallback when no challenges data is available
          <div className="space-y-2 md:space-y-4">
            <div className="pb-2 md:pb-4">
              <h4 className="text-[8px] md:text-[28px] font-bold text-[#152C24]">
                Market Access
              </h4>
              <p className="text-[6px] md:text-[20px] mt-1 md:mt-2 text-gray-700">
                Difficulty reaching premium markets and establishing consistent buyer relationships.
              </p>
              <p className="text-[6px] md:text-[20px] mt-1 md:mt-2 text-[#142B24] font-medium">
                <strong>Solution:</strong> Partner with local distributors and participate in farmer's markets
              </p>
            </div>
            
            <div className=" pb-2 md:pb-4">
              <h4 className="text-[8px] md:text-[28px] font-bold text-[#152C24]">
                Access to Finance
              </h4>
              <p className="text-[6px] md:text-[20px] mt-1 md:mt-2 text-gray-700">
                Limited access to capital for equipment, inputs, and expansion.
              </p>
              <p className="text-[6px] md:text-[20px] mt-1 md:mt-2 text-[#142B24] font-medium">
                <strong>Solution:</strong> Explore microfinance options and agricultural grants
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
  const getRegion = () => {
    if (!userData) return { name: "-", value: "-" };
    
    // Check various possible locations for region data
    if (userData.reportSelections?.REGION) {
      const region = userData.reportSelections.REGION;
      return {
        name: typeof region === 'object' ? region.name : region,
        value: typeof region === 'object' ? region.value : "-"
      };
    }
    
    if (userData.region) {
      return {
        name: typeof userData.region === 'object' ? userData.region.name : userData.region,
        value: typeof userData.region === 'object' ? userData.region.value : "-"
      };
    }
    
    return { name: "-", value: "-" };
  };

  const getArea = () => {
    if (!userData) return { name: "-", value: "-" };
    
    // Check various possible locations for area/district data
    if (userData.reportSelections?.DISTRICT) {
      const district = userData.reportSelections.DISTRICT;
      return {
        name: typeof district === 'object' ? district.name : district,
        value: typeof district === 'object' ? district.value : "-"
      };
    }
    
    if (userData.district) {
      return {
        name: typeof userData.district === 'object' ? userData.district.name : userData.district,
        value: typeof userData.district === 'object' ? userData.district.value : "-"
      };
    }
    
    return { name: "-", value: "-" };
  };

  // Helper function to safely extract membership names
  const getMembershipNames = (userData) => {
    const normalizedData = getNormalizedMembershipData(userData);
    
    if (normalizedData.selected.length > 0) {
      return normalizedData.selected.map(item => {
        if (typeof item === 'string') return item;
        if (item && typeof item === 'object') return item.value || item.name || item.label || "Membership";
        return "Membership";
      });
    }
    
    // Fallback to empty array
    return [];
  };
  

  // Helper function to safely extract membership IDs
  const getMembershipIds = (membershipData, index) => {
    if (!membershipData || !membershipData.customInputBoxes) return "12345";
    
    if (Array.isArray(membershipData.customInputBoxes)) {
      const id = membershipData.customInputBoxes[index];
      if (typeof id === 'string') return id;
      if (id && typeof id === 'object') return id.value || id.id || "12345";
    }
    
    return "12345";
  };
  const [agreed, setAgreed] = useState(false);
  const [showAgreementError, setShowAgreementError] = useState(false); // State for showing error
  const renderMembershipSection = () => {
    const membershipNames = getMembershipNames(userData);
    
    if (membershipNames.length === 0) {
      return (
        <div className="mb-6 md:mt-16 mt-2">
          <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-4">
            MEMBERSHIPS | AFFILIATIONS | GROUPS | ASSOCIATIONS
          </h2>
          <div className="text-center py-4">
            <p className="text-[6px] md:text-[16px] text-gray-500">
              No membership information available
            </p>
          </div>
        </div>
      );
    }
  
    return (
      <div className="mb-6 md:mt-16 mt-2">
        <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-4">
          MEMBERSHIPS | AFFILIATIONS | GROUPS | ASSOCIATIONS
        </h2>
        <div className="space-y-2">
          {membershipNames.map((membership, index) => (
            <div key={index}>
              {/* Membership Header */}
              <button className="w-full relative md:h-[71px] h-[20px] flex items-center justify-between px-4 rounded-[5px] cursor-pointer bg-[#142B24] text-white">
                <span className="text-white text-[8px] md:text-[32px] font-medium truncate">
                  {membership}
                </span>
                <div className="absolute top-0 right-0 w-[20px] h-[20px] md:h-full md:w-[85px] bg-[#1F1E24] text-white flex justify-center items-center rounded-r-[5px] cursor-pointer">
                </div>
              </button>
              
              {/* Membership Details */}
              <div className="flex md:mt-5 mt-2">
                <div className="bg-[#CFD7D7] h-[20px] md:h-[80px] rounded-l-[5px] md:w-[600px] w-[180px] flex items-center px-2 md:px-4">
                  <span className="text-[8px] md:text-[32px] font-medium truncate">
                    {membership.split(' ')[0].toUpperCase()}
                  </span>
                </div>
                <div className="bg-[#E7EBEB] h-[20px] md:h-[80px] rounded-r-[5px] w-full flex items-center justify-center">
                  <span className="text-black text-[8px] md:text-[36px] underline font-medium truncate">
                    Member ID: {getMembershipIds(userData, index)}
                  </span>
                </div>
              </div>
              
              {/* Additional membership information if available */}
              {renderAdditionalMembershipInfo(userData, index)}
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  // Helper function to render additional membership information
  const renderAdditionalMembershipInfo = (userData, index) => {
    const normalizedData = getNormalizedMembershipData(userData);
    const membershipName = getMembershipNames(userData)[index];
    
    const additionalInfo = [];
    
    // Add organization name if available
    if (normalizedData.organizationName && index === 0) {
      additionalInfo.push(
        <div key="org-name" className="mt-2">
          <span className="text-[6px] md:text-[16px] font-semibold">Organization: </span>
          <span className="text-[6px] md:text-[16px]">{normalizedData.organizationName}</span>
        </div>
      );
    }
    
    // Add membership type if available
    if (normalizedData.membershipType && index === 0) {
      additionalInfo.push(
        <div key="membership-type" className="mt-1">
          <span className="text-[6px] md:text-[16px] font-semibold">Type: </span>
          <span className="text-[6px] md:text-[16px]">{normalizedData.membershipType}</span>
        </div>
      );
    }
    
    // Add membership date if available
    if (normalizedData.membershipDate && index === 0) {
      additionalInfo.push(
        <div key="membership-date" className="mt-1">
          <span className="text-[6px] md:text-[16px] font-semibold">Date: </span>
          <span className="text-[6px] md:text-[16px]">
            {new Date(normalizedData.membershipDate).toLocaleDateString()}
          </span>
        </div>
      );
    }
    
    if (additionalInfo.length > 0) {
      return (
        <div className="ml-4 mt-2 p-2 bg-gray-100 rounded">
          {additionalInfo}
        </div>
      );
    }
    
    return null;
  };
  const renderButtonWithIcon = (text, bgColor, iconColor, isLarge = false, customIcon = null) => {
    const bgColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#142B24": "bg-[#142B24]",
    };
  
    const iconColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#142B24": "bg-[#142B24]",
      "#FDBB26": "bg-[#FDBB26]",
    };
  
    // Use custom icon if provided, otherwise use default expand icon
    const iconSrc = customIcon || "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756725508/Expand_down_7_hegxup.png";
  
    return (
      <div className="flex items-center">
        <div className={`${bgColorClasses[bgColor]} text-white md:text-[18px] text-[5px] px-2 md:px-4 ${
          isLarge ? "md:h-[45px] py-[3px]" : "md:h-[13px] py-[3px]"
        } md:rounded-l-md rounded-l-md font-bold md:w-[250px] whitespace-nowrap flex items-center h-full`}>
          {text}
        </div>
        
        <div className={`${iconColorClasses[iconColor]} hidden md:flex items-center md:py-4 justify-center md:w-[57px] md:h-[45px] rounded-r-md`}>
          <img
            src={iconSrc}
            alt="Expand"
            className="w-[20px] h-[6px] md:h-[25px] md:w-[30px] object-contain"
          />
        </div>
        
        <div className={`${iconColorClasses[iconColor]} md:hidden flex items-center justify-center w-[20px] h-[14px] rounded-r-md`}>
          <img
            src={iconSrc}
            alt="Expand"
            className="w-[20px] h-[6px] object-contain"
          />
        </div>
      </div>
    );
  };
  const [currentDate, setCurrentDate] = useState('');
  useEffect(() => {
    // Function to format the date as YYYY/MM/DD
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    };

    // Set initial date
    setCurrentDate(formatDate(new Date()));

    // Update the date at midnight
    const now = new Date();
    const midnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1, // Next day
      0, 0, 0 // Midnight
    );
    const timeUntilMidnight = midnight - now;

    const timer = setTimeout(() => {
      setCurrentDate(formatDate(new Date()));
      // Then update every 24 hours
      setInterval(() => {
        setCurrentDate(formatDate(new Date()));
      }, 24 * 60 * 60 * 1000);
    }, timeUntilMidnight);

    return () => clearTimeout(timer);
  }, []);
  const renderButtonWithIcon1 = (text, bgColor, iconColor, isLarge = false) => {
    const bgColorClasses = {
      "#1F1E24": "bg-[#1F1E24]",
      "#2E453D": "bg-[#2E453D]",
      "#142B24": "bg-[#142B24]",
    };
  
    const iconColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#142B24": "bg-[#142B24]",
    };
  
    return (
      <div className="flex items-center">
        <div className={`${bgColorClasses[bgColor]} text-white md:text-[18px] text-[5px] px-2 md:px-4 ${
          isLarge ? "md:h-[50px] py-[3px]" : "md:h-[13px] py-[3px]"
        } md:rounded-l-md rounded-l-md font-bold md:w-[250px] whitespace-nowrap flex items-center h-full`}>
          {text}
        </div>
        
        <div className={`${iconColorClasses[iconColor]} hidden md:flex items-center md:py-4 justify-center md:w-[60px] md:h-[50px] rounded-r-md`}>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756842517/Expand_down_8_rtaqss.png"
            alt="Expand"
            className="w-[20px] h-[6px] md:h-[25px] md:w-[30px] object-contain"
          />
        </div>
        
        <div className={`${iconColorClasses[iconColor]} md:hidden flex items-center justify-center w-[20px] h-[14px] rounded-r-md`}>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756842517/Expand_down_8_rtaqss.png"
            alt="Expand"
            className="w-[20px] h-[6px] object-contain"
          />
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (userData) {
      setEditData({
        // Use the correct field names from your registration data structure
        firstName: userData.personalInfo?.firstName || userData.firstName || "",
        surname: userData.personalInfo?.surname || userData.surname || "",
        mobile: userData.personalInfo?.mobile || userData.mobile || "",
        email: userData.personalInfo?.email || userData.email || "",
        physicalAddress: userData.personalInfo?.physicalAddress || userData.physicalAddress || "",
        registrationNumber: userData.registrationNumber || "",
        aboutText: userData.aboutSection?.aboutText || userData.aboutText || "",
        tagline: userData.aboutSection?.tagline || userData.tagline || "",
        vision: userData.industry?.vision || userData.industrySurvey?.vision || ""
      });
    }
  }, [userData]);
  const getGroupExperienceData = (userData) => {
    if (!userData) return [];
    
    // Check multiple possible locations for group experience data
    if (userData.groupExperience && Array.isArray(userData.groupExperience)) {
      return userData.groupExperience;
    }
    
    if (userData.areasOfFocus && Array.isArray(userData.areasOfFocus)) {
      return userData.areasOfFocus;
    }
    
    if (userData.focusAreas && Array.isArray(userData.focusAreas)) {
      return userData.focusAreas;
    }
    
    // Check in sectionD data
    if (userData.sectionD?.focusSelected && Array.isArray(userData.sectionD.focusSelected)) {
      return userData.sectionD.focusSelected;
    }
    
    return [];
  };
  
  // Add this function to render the Areas of Focus section
  const renderAreasOfFocusSection = () => {
    const areasOfFocus = getGroupExperienceData(userData);
    
    if (areasOfFocus.length === 0) {
      return (
        <div className="mb-6 md:mt-16 mt-2">
          <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-4">
            AREAS OF FOCUS | GROUP EXPERIENCE
          </h2>
          <div className="text-center py-4">
            <p className="text-[6px] md:text-[16px] text-gray-500">
              No areas of focus information available
            </p>
          </div>
        </div>
      );
    }
  
    return (
      <div className="mb-6 md:mt-16 mt-2">
        <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-4">
          AREAS OF FOCUS | GROUP EXPERIENCE
        </h2>
        <div className="space-y-2">
          {areasOfFocus.map((area, index) => {
            // Handle both string and object formats
            const areaName = typeof area === 'string' ? area : 
                            area.name || area.value || area.label || `Area ${index + 1}`;
            
            const areaDescription = area.description || area.desc || '';
            
            return (
              <div key={index} className="mb-4">
                {/* Area Header */}
                <button className="w-full flex justify-start items-center ">
                  <span className=" text-[8px] md:text-[32px] font-medium truncate">
                    {areaName}
                  </span>
                 
                </button>
                
                {/* Area Details */}
                {areaDescription && (
                  <div className="mt-2 p-3 bg-gray-100 rounded">
                    <p className="text-[6px] md:text-[16px] text-gray-700">
                      {areaDescription}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  const tabContent = {
    0: { // View Registration
      heading: "View Registration",
      paragraph: "To view the registration process on the Farmnet website, visit the site and navigate to the registration section, where you can explore the steps involved in creating an account and accessing the platform's farming tools and services."
    },
    1: { // Verify Registration
      heading: "Verify Registration",
      paragraph: "Verify the authenticity of registration documents by entering the registration ID. This process ensures that all information is accurate and the registration is valid within the system."
    },
    2: { // Share Registration
      heading: "Share Registration",
      paragraph: "Share registration details with authorized stakeholders. You can generate shareable links or export registration information in various formats for distribution."
    },
    3: { // Fourth tab (placeholder)
      heading: "Registration Management",
      paragraph: "Manage your registration details and preferences. Update information, modify settings, and maintain your registration profile."
    },
    4: { // Fifth tab (placeholder)
      heading: "Registration Analytics",
      paragraph: "View analytics and insights about your registration. Track performance metrics and registration status over time."
    },
    5: { // Sixth tab (placeholder)
      heading: "Registration Settings",
      paragraph: "Configure registration settings and preferences. Customize how your registration information is displayed and managed."
    },
    6: { // Seventh tab (placeholder)
      heading: "Registration Support",
      paragraph: "Get help and support for registration-related issues. Access documentation, FAQs, and contact support teams."
    }
  };

    // Function to handle button click
    const handleButtonClick = (index, path) => {
      setActiveButton(index);
      navigate(path);
    };
  
  const getDataPermissions = (userData) => {
    if (!userData) return [];
    
    // Check multiple possible locations for data permissions
    if (userData.dataPermissions && Array.isArray(userData.dataPermissions)) {
      return userData.dataPermissions;
    }
    
    if (userData.dataSelections?.selectedExperience && Array.isArray(userData.dataSelections.selectedExperience)) {
      return userData.dataSelections.selectedExperience;
    }
    
    if (userData.permissions && Array.isArray(userData.permissions)) {
      return userData.permissions;
    }
    
    // Check in section data
    if (userData.sectionD?.dataPermissions && Array.isArray(userData.sectionD.dataPermissions)) {
      return userData.sectionD.dataPermissions;
    }
    
    return [];
  };
  
  // Update the Data Section rendering function
  const renderDataSection = () => {
    const dataPermissions = getDataPermissions(userData);
    
    return (
      <div className="mb-6 md:mb-8">
        <h2 className="text-[8px] md:text-[36px] font-bold text-black">DATA</h2>
        <p className="text-[6px] md:text-[32px] italic font-medium md:mt-2 md:mb-4">
          Please choose the registered & verified users within the Myhustle system who are permitted to view your data.
        </p>
        
        {dataPermissions.length > 0 ? (
          <div className="grid grid-cols-2 md:gap-1 gap-1 mt-2 md:mt-4">
            {dataPermissions.map((permission, index) => {
              // Handle both string and object formats
              const permissionValue = typeof permission === 'string' ? permission : 
                                    permission.id || permission.value || permission.name || `Permission ${index + 1}`;
              
              // Find the corresponding stakeholder category
              const category = stakeholderCategories.find(cat => 
                cat.id === permissionValue || 
                cat.title === permissionValue ||
                (typeof permission === 'object' && permission.title === cat.title)
              );
              
              return category ? (
                <div 
                  key={index}
                  className="flex items-center justify-between w-full h-[25px] md:h-[71px] bg-[#F5F5F5]  rounded px-2"
                >
                  <span className="font-bold text-[6px] md:text-[28px]">
                    {category.title}
                  </span>
                  <span
                    className={`md:w-[55px] md:h-[55px] h-[22px] w-[22px] rounded-full border-[4px] border-white bg-[#2E453D] md:border-[6px]`}
                  />
                </div>
              ) : (
                // Fallback for permissions that don't match categories
                <div 
                  key={index}
                  className="flex items-center justify-between w-full h-[25px] md:h-[71px] bg-[#F5F5F5] border rounded px-2"
                >
                  <span className="font-bold text-[6px] md:text-[28px]">
                    {permissionValue}
                  </span>
                  <span
                    className={`md:w-[55px] md:h-[55px] h-[22px] w-[22px] rounded-full border-[4px] border-white bg-[#2E453D] md:border-[6px]`}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          // Fallback UI when no data permissions are available
          <div className="text-center py-4 bg-gray-50 rounded-lg mt-2">
            <p className="text-[6px] md:text-[16px] text-gray-500 mb-2">
              No data sharing preferences selected during registration
            </p>
            <div className="grid grid-cols-2 md:gap-1 gap-1">
              {['Government Agencies', 'Financial Institutions'].map((defaultOption, index) => (
                <div 
                  key={index}
                  className="flex items-center justify-between w-full h-[25px] md:h-[71px] bg-[#E7EBEB] border rounded px-2 opacity-50"
                >
                  <span className="font-bold text-[6px] md:text-[28px] text-gray-400">
                    {defaultOption}
                  </span>
                  <span
                    className={`md:w-[55px] md:h-[55px] h-[22px] w-[22px] rounded-full border-[4px] border-white bg-gray-300 md:border-[6px]`}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  const currentContent = tabContent[activeButton] || tabContent[0];

  return (
    <div className="w-full overflow-x-auto bg-white" >
      <div className='md:px-10 px-4 md:pt-6 pt-2 '>
        <div className='md:px-10'>
        <h1 className='md:text-[36px] font-bold text-[8px] mb-2' >  Registration</h1>

         {/* Buttons Row */}
    <div className="grid grid-cols-7 gap-1 md:gap-2 w-full mb-4 md:mb-8">
            {buttons.map((btn, index) => (
              <button
                key={index}
                onClick={() => handleButtonClick(index, btn.path)}
                className={`
                  h-4 md:h-10 lg:h-[40px] 
                  rounded-[2px] shadow-md 
                  text-[4px] md:text-sm lg:text-[14px] font-normal
                  bg-[#152C24] text-white
                  border-b-2 
                  ${
                    activeButton === index
                      ? "border-[#FDBD26]"
                      : "border-gray-400"
                  }
                  hover:bg-[#1a3a30] transition-colors duration-200
                `}
              >
                {btn.label}
              </button>
            ))}
          </div>
      {/* Section Heading */}
      <h2 className="text-xl md:text-[24px] lg:text-[24px] font-bold mb-4">
            {currentContent.heading}
          </h2>

          {/* Dynamic Paragraph */}
          <p className="text-base md:text-[24px] lg:text-[24px] font-normal mb-10">
            {currentContent.paragraph}
          </p>
        
          
          {/* Search Section */}
          <div className="flex flex-row items-center md:mb-4 md:mt-5 mt-2 relative w-full">
            <input
              type="text"
              placeholder="Please enter the ID number from the registration document to view the information, then click 'Search'."
              className="h-6 md:h-[60px] w-full md:text-[20px] text-[6px] rounded-[20px] border-[0.5px] border-[#979797] placeholder:text-[6px] placeholder:text-black placeholder:font-regular md:placeholder:text-[16px] px-4 pr-14 mb-2 md:mb-0"
              value={searchId}
              onChange={(e) => setSearchId(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            />
            <div 
              className="absolute right-4 w-[12px] md:w-[42px] h-[12px] md:h-[42px] cursor-pointer"
              onClick={handleSearch}
            >
              <img
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756749481/Search_light_l40m53.png"
                alt="search"
                className="w-full h-full"
              />
            </div>
          </div>
          
          {error && (
            <div className="text-red-500 md:text-[16px] text-[6px] mb-4">
              {error}
            </div>
          )}
          
          {loading && (
            <div className="flex justify-center my-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
            </div>
          )}

          <div className='md:mt-3 mt-1 flex justify-between items-center'>
          <div>
              <h1 className='md:text-[20px] text-[6px] font-bold md:mb-1'>DELETE REGISTRATION</h1>
              {renderButtonWithIcon("DELETE", "#2E453D", "#142B24",  true, "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759869401/Trash_duotone_line_hfmms1.png")}
              <p className="md:text-[14px] text-[4px] font-normal mt-1">Click to delete registation</p>
            </div>
            <div>
  <h1 className='md:text-[20px] text-[6px] font-bold md:mb-1'>EDIT REGISTRATION</h1>
  <div onClick={handleEditToggle} style={{ cursor: 'pointer' }}>
    {renderButtonWithIcon(
      isEditing ? "CANCEL EDIT" : "EDIT", 
      "#2E453D", 
      "#142B24", 
      true,
      "https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
    )}
  </div>
  <p className="md:text-[14px] text-[4px] font-normal mt-1">
    {isEditing ? 'Click to cancel editing' : 'Click to Edit registration'}
  </p>
</div>
           
              
              <div>
  <h1 className='md:text-[20px] text-[6px] font-bold md:mb-1'>SAVE REGISTRATION</h1>
  <div onClick={generatePDF} style={{ cursor: 'pointer' }}>
    {renderButtonWithIcon("SAVE", "#2E453D", "#142B24", true, "https://res.cloudinary.com/dzngpgki4/image/upload/v1748279791/Arhive_load_duotone_line_ukwrm4.png")}
  </div>
  <p className="md:text-[14px] text-[4px] font-normal mt-1">
    {saving ? 'Generating PDF...' : 'Click to save registration as PDF'}
  </p>
</div>
          
            <div>
              <h1 className='md:text-[20px] text-[6px] font-bold md:mb-1'>SHARE REGISTRATION</h1>
              {renderButtonWithIcon("SHARE", "#2E453D", "#FDBB26",  true, "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759869394/Send_hor_fill_2x_alkbyr.png")}
              <p className="md:text-[14px] text-[4px] font-normal mt-1">Click to share registation</p>
            </div>
          </div>
        </div>
        
        <div ref={contentRef} className="w-full md:px-10 px-2 md:mt-0 mt-2">
        {userData ? (
          <div className="w-full mx-auto bg-white rounded-lg mb-4">
            <div className='mb-6'>
              <div className="flex items-center justify-between md:mt-5 mb-4 md:mb-8">
                <img 
                  src='https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758808007/image_2533_xmvbhj.png' 
                  alt="Logo" 
                  className='h-4 md:h-[100px] md:-ml-6'
                />
                
                <div className="flex-1 text-center">
                  <h1 className="text-[12px] md:text-[54px] font-extrabold text-black">
                    REGISTRATION
                  </h1>
                </div>

                <div className="flex flex-col items-end">
    <img
      src={selectedCountry.flag || "https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/flag_placeholder.png"}
      alt="Country Flag"
      className="w-4 h-2 md:w-20 md:h-14 border"
    />
    <span className="text-[6px] mt-0 md:mt-2 md:text-[20px] italic text-left font-normal w-full">
      {selectedCountry.name || userData.country || "Country Name"}
    </span>
  </div>
              </div>
            </div>

            <div className="w-full md:mt-8">
              <div>
              <div className='mb-4 md:mb-8 md:mt-8 mt-2'>
                <div className="md:-mt-4 -mt-2">
                  {isEditing ? (
                    <>
                      <div className="flex gap-2 mb-3">
                        <input
                          type="text"
                          className="p-0 bg-transparent border-none outline-none focus:ring-0 focus:outline-none  md:text-[32px] text-[12px] outline-none w-1/2"
                          value={editData.username || ""}
                          onChange={(e) => handleEditChange('username', e.target.value)}
                          placeholder="First Name"
                        />
                        <input
                          type="text"
                          className=" p-0  bg-transparent border-none outline-none focus:ring-0 focus:outline-none  md:text-[32px] text-[12px] outline-none w-1/2"
                          value={editData.surname || ""}
                          onChange={(e) => handleEditChange('surname', e.target.value)}
                          placeholder="Last Name"
                        />
                      </div>
                      <p className="text-[6px] md:text-[24px] md:mt-[11px] font-bold">
                        <span className="text-[#979797]">ID NO:</span> {userData.registrationNumber || "REG123456"}
                      </p>
                    </>
                  ) : (
                    <>
                    <h2 className="text-[10px] md:text-[32px] font-bold  md:-mb-3">
      {/* Display the correct fields from userData */}
      {userData.personalInfo?.firstName || userData.firstName} {userData.personalInfo?.surname || userData.surname}
    </h2>
                      <p className="text-[6px] md:text-[24px] md:mt-[11px] font-bold">
                        <span className="text-[#979797]">ID NO:</span> {userData.registrationNumber || "REG123456"}
                      </p>
                    </>
                  )}
                </div>


                  <div className="flex items-center justify-between -mt-[50px] md:-mt-[100px]">
                    <div className="flex-1 border-t border-[#979797]"></div>

                    <div>
                      <img
                        src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756734960/image_1934_oo9peb.png"
                        alt="QR Code"
                        className="w-12 h-12 md:w-[220px] md:h-[220px] ml-2"
                      />
                    </div>
                  </div>

                  <div className='flex items-center justify-between md:-mt-[90px]'>
                  <div>
                    {isEditing ? (
                      <>
                        <input
                          type="text"
                          className="p-0  bg-transparent border-none outline-none focus:ring-0 focus:outline-none md:text-[20px] text-[6px] outline-none w-full mb-1"
                          value={editData.mobile || ""}
                          onChange={(e) => handleEditChange('mobile', e.target.value)}
                          placeholder="Mobile Number"
                        />
                        <input
                          type="email"
                          className=" p-0  bg-transparent border-none outline-none focus:ring-0 focus:outline-none md:text-[20px] text-[6px] outline-none w-full mb-1"
                          value={editData.email || ""}
                          onChange={(e) => handleEditChange('email', e.target.value)}
                          placeholder="Email Address"
                        />
                      <input
  type="text"
  className=" p-0 bg-transparent border-none outline-none focus:ring-0 focus:outline-none md:text-[20px] text-[6px] w-full"
  value={editData.physicalAddress || ""}
  onChange={(e) => handleEditChange('physicalAddress', e.target.value)}
  placeholder="Physical Address"
/>

                      </>
                    ) : (
                      <>
                        <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold">    Email: {userData.personalInfo?.email || userData.email || "example@email.com"}</p>
                      </>
                    )}
                    <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold">Date: {userData.createdAt ? new Date(userData.createdAt.seconds * 1000).toLocaleDateString() : "January 1, 2025"}</p>
                  </div>
                  
                  <p className="text-[6px] md:text-[18px] text-[#979797] tracking-wider leading-snug md:leading-[1.60] font-light text-left max-w-[150px] md:max-w-[400px] mr-12 md:mr-44 -mt-2 md:-mt-4">
                    To ensure this registration is authentic, scan the QR Code and verify against original information and report
                  </p>
                </div>
              </div>
              <div className="md:mt-3 mt-1 relative">
                  <div 
                    className="relative w-full h-[160px] md:h-[705px] bg-cover md:rounded-md rounded-[2px] bg-center transition-all duration-300" 
                    style={{ 
                      backgroundImage: backgroundImage ? `url(${backgroundImage})` : "linear-gradient(to bottom, #D9D9D9, #D9D9D9)",
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundColor: backgroundImage ? 'transparent' : '#D9D9D9'
                    }}
                  >
                    {/* Placeholder text when no background image */}
                    {!backgroundImage && (
                      <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4">
                        <p className="text-[#979797] font-bold text-[8px] md:text-[40px] md:mb-2">
                          No Background Image Available
                        </p>
                        <p className="text-[#979797] font-normal text-[6px] md:text-[24px]">
                          Background image not uploaded during registration
                        </p>
                      </div>
                    )}

                    {/* Profile image area */}
                    <div className="absolute bottom-1 left-1 md:bottom-6 md:left-6 flex flex-col items-center">
                      <div className="relative h-[70px] w-[70px] md:w-[250px] md:h-[250px]">
                        {/* Profile image */}
                        {profileImage ? (
                          <div 
                            className="w-full h-full bg-cover bg-center rounded-full " 
                            style={{ backgroundImage: `url(${profileImage})` }} 
                          />
                        ) : (
                          <div className="w-full h-full bg-[#B3B3B3] rounded-full flex flex-col items-center justify-center text-center border-4 border-white">
                            <span className="text-[#979797] text-[4px] md:text-[16px]">
                              No Profile Image
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                
                  </div>
                </div>
                <div className="flex flex-row w-full gap-2 md:mt-6 mt-2 md:mb-6">
  {/* COUNTRY */}
  <div className="flex flex-col w-1/4">
    <h3 className="md:text-[20px] text-[6px] font-bold mb-1">COUNTRY</h3>
    <div className="flex w-full">
      <button className="flex-1 w-full h-[15px] md:h-[53px] bg-[#2E453D] text-white font-medium flex items-center justify-center px-2 rounded-l-[5px]">
        <span className="md:text-[18px] text-[6px] truncate">{getCountryData().name}</span>
      </button>
      <div className="w-[25%] h-[15px] md:h-[53px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer">
        {getCountryData().code !== "-" && (
          <span className="md:text-[18px] text-[4px] truncate font-medium">
            {getCountryData().code}
          </span>
        )}
      </div>
    </div>
  </div>

  {/* LANGUAGE */}
  <div className="flex flex-col w-1/4">
    <h3 className="text-[6px] md:text-[20px] font-bold mb-1">LANGUAGE</h3>
    <button className="w-full h-[15px] md:h-[53px] bg-[#152C24] text-white font-bold flex justify-center items-center text-[6px] md:text-[17px] px-2 rounded-[4px] truncate">
      {getLanguage()}
    </button>
  </div>

  {/* TYPE OF FARMING */}
  <div className="flex flex-col w-1/4">
    <h3 className="text-[6px] md:text-[20px] font-bold mb-1">TYPE OF FARMING</h3>
    <button className="w-full h-[15px] md:h-[53px] bg-[#152C24] text-white font-bold flex justify-center items-center text-[6px] md:text-[17px] px-2 rounded-[4px] truncate">
      {getFarmingType()}
    </button>
  </div>

  {/* TYPE OF USER */}
  <div className="flex flex-col w-1/4">
    <h3 className="text-[6px] md:text-[20px] font-bold mb-1">TYPE OF USER</h3>
    <button className="w-full h-[15px] md:h-[53px] bg-[#152C24] text-white font-bold flex justify-center items-center text-[6px] md:text-[17px] px-2 rounded-[4px] truncate">
      {getUserType()}
    </button>
  </div>
</div>


              {/* PROVINCE/REGION and AREA Section */}
              <div className="mb-6 md:mb-8 mt-3 md:mt-6 flex justify-between items-center">
                <div className='flex gap-1'>
                  {/* PROVINCE / REGION */}
                  <div>
                    <h3 className="md:text-[20px]  text-[6px] font-bold md:mb-1">PROVINCE / REGION</h3>
                    <button className="relative xl:w-[300px] lg:w-[140px] md:w-[100px] w-[67px] h-[15px] md:h-[53px] bg-[#152C24] text-white flex justify-between items-center text-[4px] md:text-[17px] px-[2px] rounded-[4px] truncate">
                      <span className="whitespace-normal break-words font-bold leading-[0.90] text-left px-2 capitalize w-full">
                        {getRegion().name}
                      </span>
                      {getRegion().value !== "-" && (
                        <span className="absolute bottom-[1px] right-3 text-[3px] md:text-[8px] text-white">
                          {getRegion().value}
                        </span>
                      )}
                    </button>
                  </div>
                  
                  {/* AREA */}
                  <div>
                    <h3 className="md:text-[20px]  text-[6px] font-bold md:mb-1">AREA</h3>
                    <button className="relative xl:w-[300px] lg:w-[140px] md:w-[100px] w-[67px] h-[15px] md:h-[53px] bg-[#152C24] text-white flex justify-between items-center text-[4px] md:text-[17px] px-[2px] rounded-[4px] truncate">
                      <span className="whitespace-normal break-words font-bold leading-[0.90] text-left px-2 capitalize w-full">
                        {getArea().name}
                      </span>
                      {getArea().value !== "-" && (
                        <span className="absolute bottom-[1px] right-3 text-[3px] md:text-[6px] text-white">
                          {getArea().value}
                        </span>
                      )}
                    </button>
                  </div>
                </div>
                <div className='text-right'>
      <h1 className='md:text-[32px] font-bold text-[8px]'>{currentDate}</h1>
      <p className='md:text-[16px] text-[8px] font-normal  md:-mt-1'>Registration date</p>
    </div>
                </div>  
                 
                <div>
                    <div className="flex gap-2 items-center">
                    <h1 className='md:text-[36px] text-[8px] font-bold'>About Us</h1>
<StarRating/>
                    </div>
                    {isEditing ? (
                      <textarea
                        className='p-0 bg-transparent border border-gray-300 rounded outline-none focus:ring-0 focus:outline-none md:text-[24px] font-normal text-[8px] mt-1 w-full'
                        value={editData.aboutText || ""}
                        onChange={(e) => handleEditChange('aboutText', e.target.value)}
                        placeholder="Enter about us text"
                        rows={4}
                      />
                    ) : (
                      <p className='md:text-[24px] font-normal text-[8px] mt-1'>
                        {getAboutText()}
                      </p>
                    )}
                  </div>
                  
          <div className='flex justify-center items-center mt-2  md:mt-6'>
  
            {isEditing ? (
                      <input
                        type="text"
                        className="p-0 bg-transparent border-none outline-none focus:ring-0 focus:outline-none md:h-[53px] h-[20px] w-full flex justify-center items-center md:text-[24px] text-[6px] text-center "
                        value={editData.tagline || ""}
                        onChange={(e) => handleEditChange('tagline', e.target.value)}
                        placeholder="Enter tagline"
                      />
                    ) : (
                      <div className="md:h-[53px] h-[20px]  w-full flex justify-center items-center ">
                        <h1 className='md:text-[24px] font-bold text-[6px] text-center'>{getTagline()}</h1>
                      </div>
                    )}
          </div>
                
                <div className="w-full mt-4">
                {renderProductsSection()}
                </div>

                <div className="mb-6 md:mb-8 md:mt-16">
  <div className="flex relative z-20 w-full">
              <button className={`md:w-[520px] w-[80px] h-[15px] md:h-[64px] bg-[#152C24] rounded-[5px] flex items-center justify-between pl-4`}>
                <span className="md:text-[32px] text-[6px] truncate font-bold text-white">
                DOCUMENTS
                </span>
              </button>
              <div className="md:h-[64px] h-[15px] w-[20px] md:w-[80px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                  alt="expand"
                  className="md:w-6 w-2 h-[8px] md:h-[24px]"
                />
              </div>
            </div>
  <div className="grid grid-cols-4 md:grid-cols-4 gap-1.5 md:gap-2">
    {/* Check multiple possible locations for certificates data */}
    {(userData.certificates || 
      userData.organizationInfo?.certificates || 
      userData.certificatesUrls || 
      []).slice(0, 4).map((cert, index) => {
      
      // Normalize certificate data structure
      const certificate = {
        title: cert.title || cert.documentType || `Certificate ${index + 1}`,
        url: cert.url || cert.img || cert.cloudinaryUrl || cert.previewUrl || '',
        type: cert.type || 'certificate'
      };

      return (
        <div key={index} className="flex flex-col mt-2 md:mt-6">
          <p className="text-[8px] md:text-[24px] font-light italic md:mb-3 text-left md:h-[60px] md:w-[260px] leading-tight">
            {certificate.title}
          </p>
          <div className="relative bg-[#D9D9D9] rounded-[5px] h-24 md:h-[400px] w-full overflow-hidden">
            {certificate.url ? (
              // Check if it's a PDF or image
              certificate.url.toLowerCase().endsWith('.pdf') ? (
                <div className="w-full h-full flex flex-col items-center justify-center p-2">
                  <img
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1757034567/pdf-icon.png"
                    alt="PDF Document"
                    className="w-12 h-12 md:w-24 md:h-24 mb-2"
                  />
                  <span className="text-[6px] md:text-[14px] text-center">
                    PDF Document
                  </span>
                  <a 
                    href={certificate.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-500 text-[6px] md:text-[14px] underline mt-1"
                  >
                    View PDF
                  </a>
                </div>
              ) : (
                <img
                  src={certificate.url}
                  alt={certificate.title}
                  className="object-cover w-full h-full"
                  onError={(e) => {
                    // Handle broken images
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              )
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <span className="text-gray-500 text-[6px] md:text-[14px]"></span>
              </div>
            )}
            
            {/* Fallback for broken images */}
            {certificate.url && !certificate.url.toLowerCase().endsWith('.pdf') && (
              <div 
                className="w-full h-full flex items-center justify-center hidden"
                style={{display: 'none'}}
              >
                <span className="text-gray-500 text-[6px] md:text-[14px]">Image not available</span>
              </div>
            )}
          </div>
        </div>
      );
    })}
    
    {/* Fallback for when no certificates are found */}
    {(userData.certificates || userData.organizationInfo?.certificates || userData.certificatesUrls || []).length === 0 && (
      <div className="col-span-4 text-center py-8">
        <span className="text-gray-500 text-[6px] md:text-[14px]">
          No documents uploaded during registration
        </span>
      </div>
    )}
  </div>
</div>

            <PromotionDisplaySection userData={userData} />    

          
                <div className="mb-6 md:mt-16 mt-2">
                {renderMembershipSection()}
                </div>

                <div className="mb-6 md:mb-8 md:mt-16">
                {renderAreasOfFocusSection()}

                </div>
  
    <div className="mb-6 md:mb-10 md:mt-10">
<div>
  {renderIndustrySection()}
  </div>  
</div>

<div className="mb-6 md:mb-8">
{renderDataSection()}
</div>
                </div>
                {renderReferralSection()}
                <h1 className="text-[8px] md:text-[36px] md:mt-6 mt-2 font-bold">
                  LOCATION
                </h1>
                
                <div className="mt-2 md:mt-3 flex items-center space-x-2 md:space-x-3">
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744662306/image_1570_pnbwi8.png"
                    alt="Location icon"
                    className="w-4 h-4 md:w-[37px] md:h-[37px]"
                  />
                  <h1 className="text-sm mt-1 md:text-[36px] font-bold">
                    {userData.locationCountry || "Set Location"}
                  </h1>
                </div>
                
              

                <div className="mb-8 md:h-[40px]"></div>

                <div className="mt-6 md:mt-5 md:mb-6 pt-2 md:pt-4">
                  <p className="text-[6px] md:text-[24px] leading-[1.20]">
                    <span className='text-black font-bold '>Disclaimer: </span>Users are advised to verify all entries independently and consult with their financial or legal advisors before making any decisions based on the information provided. Myhustle shall not be held liable for any loss or damage arising directly or indirectly from the use of or reliance on this statement.
                  </p>
                </div>      
              </div>
            </div>
        ) : (
          // Show empty state when no user data is found
          <div className="max-w-7xl mx-auto bg-white rounded-lg p-8 text-center">
            <p className="md:text-[24px] text-[8px]">Enter a registration number above to view user details</p>
            
          </div>
        )}
        <div className="flex justify-end items-end md:mt-1 ">
            <div className="flex w-fit mt-6">
      <button className={`xl:w-[220px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[44px] bg-[#152C24] text-white font-bold flex items-center px-1 rounded-l-[5px]`}>
        <div className="md:text-[16px] md:px-2 text-[4px] font-cold md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white">Share Document</div>
      </button>
      <div className="w-[15px] h-[15px] md:h-[44px] md:w-[50px] bg-[#FDBB26] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
          alt="expand"
          className="w-2 h-[10px] md:w-6 md:h-[24px]"
        />
      </div>
    </div>
    </div>

                                  <div className="flex gap-4 items-center mt-5">
                          <div
                              className="md:w-16 md:h-[63px] w-6 h-[20px] rounded-[5px] bg-[#D9D9D9] flex items-center justify-center cursor-pointer transition"
                              onClick={() => {
                                  setAgreed((prev) => !prev);
                                  setShowAgreementError(false); // Clear error when checkbox is clicked
                              }}
                              tabIndex={0}
                              aria-pressed={agreed}
                              aria-label="Confirm terms and conditions">
                              {/* Black or Green Check Round Fill SVG */}
                              {agreed ? (
                                  // GREEN CHECK ROUND FILL
                                  <svg
                                      width="54"
                                      height="54"
                                      viewBox="0 0 54 54"
                                      fill="none"
                                      className="md:w-[54px] md:h-[54px] w-[15px] h-[15px] transition-all duration-150"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle
                                          cx="27"
                                          cy="27"
                                          r="27"
                                          fill="#152C24"
                                      />
                                      <path
                                          d="M39 21L24.75 35L15 25.4545"
                                          stroke="white"
                                          strokeWidth="4"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                      />
                                  </svg>
                              ) : (
                                  // BLACK CHECK ROUND FILL
                                  <svg
                                      width="54"
                                      height="54"
                                      viewBox="0 0 54 54"
                                      fill="none"
                                      className="md:w-[54px] md:h-[54px] w-[15px] h-[15px] transition-all duration-150"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle
                                          cx="27"
                                          cy="27"
                                          r="27"
                                          fill="#222"
                                      />
                                      <path
                                          d="M39 21L24.75 35L15 25.4545"
                                          stroke="white"
                                          strokeWidth="4"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                      />
                                  </svg>
                              )}
                          </div>
                          <p className="md:text-[20px] text-[6px]">
                              By ticking I confirm that I agree with the{" "}
                              <a
                                  className="underline hover:text-[#152C24]"
                                  href="/TermsAndCondition">
                                  Terms and conditions
                              </a>
                              ,<a href="/DataPolicy"     className="underline hover:text-[#152C24]">Data </a>and{" "}
                              <a
                                  className="underline hover:text-[#152C24]"
                                  href="/PrivacyPolicy">
                                  Privacy policy
                              </a>
                              .
                                 <p
                          className={`md:text-[14px] text-[10px] ${
                              agreed
                                  ? "text-white hidden "
                                  : " text-red-600 cursor-not-allowed"
                          }`}>
                          Please agree to the terms and conditions before
                          proceeding.
                      </p>
                          </p>

                   

                      {/* Text */}
                  </div>
                  <div  className="flex justify-between items-center md:mt-6 mb:mb-6">
<div className="flex flex-col   ">
                          {/* Buttons */}
                          <div className="flex md:gap-4 gap-1   mt-2">

                           {/* Save Button */}
                           <div>
               
<div>
<button
  className="flex items-center justify-between w-[60px] md:w-[190px] h-[15px] md:h-[44px] bg-[#FDBB26] text-white md:text-[14px] text-[6px] font-bold rounded-[5px] px-1 md:px-4"
>
  <span>DELETE</span>
  <img 
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279697/Trash_1_afo0yz.png" 
      alt="Delete" 
      className="md:w-[30px] h-[6px] md:h-[30px] w-[6px]"
  />
</button>
<p className="md:text-[14px] text-[6px] mt-1 font-normal md:px-1">
  Delete registration 
</p>
</div>

                                  {/* Save Confirmation Modal */}
                                 {/* Delete Confirmation Modal */}
         
  </div>

                              {/* Edit Button */}
                              <div>
                                  <button
                                      className="flex items-center justify-between md:w-[190px] w-[60px] md:h-[44px] h-[15px] bg-[#2E453D] text-white md:text-[14px] md:px-4 px-1 text-[6px] font-bold rounded-[5px]">
                                    
                                      <span>EDIT</span>
                                      <img
                                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
                                          alt="Edit Icon"
                                          className="md:w-[30px] h-2  md:h-[30px] w-2"
                                      />
                                  </button>

                                  <p className="md:text-[14px] text-[6px]  mt-1 font-normal md:px-1 ">
                                      Edit registration form
                                  </p>
                          
                              </div>

                       {/* Save Button */}
                              <div>
                                  {/* Save Button */}
                                  <div>
                                      <button
                                          className="flex items-center justify-between w-[60px] md:w-[190px] h-[15px] md:h-[44px] bg-[#2E453D] text-white md:text-[14px] text-[6px] font-bold rounded-[5px] px-1 md:px-4"
                                          >
                                          <span>SAVE ALL</span>
                                          <img
                                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279791/Arhive_load_duotone_line_ukwrm4.png"
                                          alt="Edit Icon"
                                          className="md:w-[30px] h-[6px]  md:h-[30px] w-[6px]"
                                      />
                                      </button>
                                      <p className="md:text-[14px] text-[6px]  mt-1 font-normal md:px-1">
                                          Save registration
                                      </p>
                                  </div>

                                  {/* Save Confirmation Modal */}
                         

                                  {/* Registration Confirmation Modal */}
                                  
                              </div>

                          </div>
                      </div>
        <div className="flex items-center md:gap-3 gap-1">
        <a href="/Policy">

<div>
              {renderButtonWithIcon("POLICIES", "#152C24", "#FDBB26", true)}
              <p className="md:text-[14px] text-[4px]  font-normal mt-1">Click to view policies</p>
            </div>
</a>
                      <a 
href="/document"
>
  <div >
  <div>
    <div className="flex w-fit">
      <button className={`xl:w-[220px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[44px] bg-[#152C24] text-white font-bold flex items-center px-1 rounded-l-[5px]`}>
        <div className="md:text-[16px] md:px-2 text-[4px] font-cold md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white">View Registration</div>
      </button>
      <div className="w-[15px] h-[15px] md:h-[44px] md:w-[50px] bg-[#FDBB26] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
          alt="expand"
          className="w-2 h-[10px] md:w-6 md:h-[24px]"
        />
      </div>
    </div>
    <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
      View Document
    </p>
  </div>
  </div>
</a>
        </div>
</div>
                <div className="mb-8 md:h-[10px]"></div>

        </div>
      </div>
    </div>
  );
};

export default ViewRegistration;